import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from "next/link";
import { memo } from "react";
import { CatInBoxAsset } from "~/components/Assets/CatInBoxAsset";
import { NullState } from "~/components/NullState";
export const NoSearchResults = /*#__PURE__*/ memo((param)=>{
    let { location, children } = param;
    return /*#__PURE__*/ _jsx(NullState, {
        title: location ? "No results found in ".concat(location) : "No results found",
        children: /*#__PURE__*/ _jsxs("div", {
            "data-testid": "NO_SEARCH_RESULTS",
            className: "mt-2 flex flex-col items-center",
            children: [
                children,
                /*#__PURE__*/ _jsx(CatInBoxAsset, {
                    className: "mb-8 mt-20"
                }),
                /*#__PURE__*/ _jsx(Link, {
                    className: "text-12",
                    rel: "noreferrer",
                    href: "https://help.air.inc/en/articles/3397283-searching-for-your-content",
                    target: "_blank",
                    children: "Learn how search works in Air"
                })
            ]
        })
    });
});
NoSearchResults.displayName = "NoSearchResults";
